import React from 'react';
// settings
// components

import StartColumnsContainer from 'modules/emergencies/components/ui/containers/startColumnsContainer';
import HeaderRow from 'modules/emergencies/components/ui/rows/headerRow';
import HeaderColumn from 'modules/emergencies/components/ui/columns/headerColumn';
import HeaderText from 'modules/emergencies/components/ui/texts/HeaderText';
import styled from 'styled-components';
import { SETTINGS } from 'modules/emergencies/constants';

const CustomStartColumnsContainer = styled(StartColumnsContainer)`
  width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

const columnWidths = SETTINGS.FILTER_VIEWS_TABLE_COLUMN_SIZES_IN_PX;
const headerColumns = {
  startColumns: [
    {
      width: columnWidths.NAME,
      text: 'VIEW',
    },
    {
      width: columnWidths.ACTIONS,
      text: '',
    },
  ],
};

const FilterViewsListTableHeaderRow = () => {
  return (
    <HeaderRow>
      <CustomStartColumnsContainer>
        {headerColumns.startColumns.map((column, index) => (
          <HeaderColumn key={index} width={column.width} centerContent={!!column.centerContent}>
            <HeaderText>{column.text}</HeaderText>
          </HeaderColumn>
        ))}
      </CustomStartColumnsContainer>
    </HeaderRow>
  );
};

export default FilterViewsListTableHeaderRow;
